import { getList } from "./generics";
import { WebhookEvent } from "../models/webhook-endpoint";

export const getWebhookEventList = (
  taxPayerId: number,
  endpointId?: number,
  page: number = 1,
  status?: string,
  eventType?: string,
  entityType?: string,
  dateFrom?: string,
  dateTo?: string
) => {
  const additionalParams = new Map<string, string>();
  additionalParams.set("tax_payer_id", taxPayerId.toString());
  if (endpointId !== undefined) {
    additionalParams.set("endpoint_id", endpointId.toString());
  }
  additionalParams.set("page", page.toString());
  if (status) {
    additionalParams.set("status", status);
  }
  if (eventType) {
    additionalParams.set("event_type", eventType);
  }
  if (entityType) {
    additionalParams.set("entity_type", entityType);
  }
  if (dateFrom) {
    additionalParams.set("date_from", dateFrom);
  }
  if (dateTo) {
    additionalParams.set("date_to", dateTo);
  }
  return getList<WebhookEvent>("/webhook_events/", 50, 0, additionalParams);
};
